var _require = require('../overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
module.exports = function (options) {
  var title = options.title,
    value = options.value,
    multiline = options.multiline,
    placeholder = options.placeholder,
    submitLabel = options.submitLabel;
  var safeValue = String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  var safeTitle = String(title !== null && title !== void 0 ? title : 'Text');
  var safePlaceholder = String(placeholder !== null && placeholder !== void 0 ? placeholder : '');
  var safeSubmit = String(submitLabel !== null && submitLabel !== void 0 ? submitLabel : 'Apply');
  var inputBlock = multiline ? "<textarea class=\"saito-textarea rs-prompt-value rs-prompt-generic-input\" spellcheck=\"false\" placeholder=\"".concat(safePlaceholder, "\">").concat(safeValue, "</textarea>") : "<input\n      type=\"text\"\n      class=\"saito-input rs-prompt-value rs-prompt-single-input\"\n      value=\"".concat(safeValue.replace(/"/g, '&quot;'), "\"\n      placeholder=\"").concat(safePlaceholder, "\"\n      autocomplete=\"off\"\n      spellcheck=\"false\"\n    />");
  return buildRustscriptOverlay({
    className: "rs-overlay-prompt rs-prompt-generic".concat(multiline ? ' rs-prompt-generic-multiline' : ' rs-prompt-generic-single'),
    title: safeTitle,
    bodyHtml: "\n      ".concat(inputBlock, "\n      <p class=\"rs-prompt-validation\" hidden></p>\n    "),
    actionsHtml: "<button type=\"button\" class=\"rs-btn rs-btn-primary rs-prompt-apply\">".concat(safeSubmit, "</button>")
  });
};